import { ColorSource, EventMode } from 'pixi.js'
import { ReactNode, useCallback } from 'react'
import { Graphics } from '@pixi/react'
import { Draw } from '../type/PixiType'
import { FixedContainer } from './FixedContainer'

interface PanelProps {
  x: number
  y: number
  width: number
  height: number
  children?: ReactNode
  backgroundColor?: ColorSource
  border?: {
    color: ColorSource
    width: number
  }
  radius?: number
  name?: string
  eventMode?: EventMode
}

export const Panel = (props: PanelProps) => {
  const draw = useCallback<Draw>((g) => {
    g.clear()
    let startPosition = 0
    let width = props.width
    let height = props.height

    g.beginFill(props.backgroundColor)

    if (props.border) {
      const border = props.border
      g.lineStyle(border)
      startPosition += border.width / 2
      width -= border.width
      height -= border.width
    }

    if (props.radius) {
      g.drawRoundedRect(startPosition, startPosition, width, height, props.radius)
    }
    else {
      g.drawRect(startPosition, startPosition, width, height)
    }
    g.endFill()
  }, [props.backgroundColor, props.border, props.height, props.radius, props.width])

  return (
    <FixedContainer name={props.name ? props.name : 'Panel'} x={props.x} y={props.y} width={props.width} height={props.height}>
      <Graphics eventMode={props.eventMode ? props.eventMode : 'auto'} name="Background" draw={draw} />
      {props.children}
    </FixedContainer>
  )
}
